import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/NotificationDrawer/notification-drawer.mjs';
export const NotificationDrawerGroupList = (_a) => {
    var { children, className = '' } = _a, props = __rest(_a, ["children", "className"]);
    return (_jsx("div", Object.assign({}, props, { className: css(styles.notificationDrawerGroupList, className), children: children })));
};
NotificationDrawerGroupList.displayName = 'NotificationDrawerGroupList';
//# sourceMappingURL=NotificationDrawerGroupList.js.map